<template>
  <f-modal
    :class="{ 'is-visible': isVisible }"
    @close="handleClose">
    <f-modal-header>
      <h3 class="heading-medium">
        {{ $t('inquiryLiabilitiesInfo.yourExpertAssessment') }} {{ adviserName }} {{ adviserSurname }}
      </h3>
    </f-modal-header>

    <f-modal-body>
      <validation-observer
        ref="inquiry-opinion-popup-form"
        tag="form">

        <div class="form-group">
          <label for="note" class="mb-1">
            {{ $t('ui.assessment') }}:
          </label>
          <validation-provider
            rules="required|min_value:1"
            name="note"
            v-slot="{ errors }">
            <f-input
              hidden
              v-model="data.note"
              :state="errors.length ? 'invalid' : null"/>
            <div class="flex flex-align-items-center rating-wrapper">
              <div
                v-for="(index) of 5"
                :key="'rating-' + index"
                :class="{
                  'star-wrapper': true,
                  'is-selected': data.note >= index
                }"
                @click.prevent="setRating(index)">
                <f-icon
                  name="star"
                  class="rating-star" />
              </div>

              <span class="ml-2">{{ data.note }}/5</span>

            </div>
            <div class="invalid-feedback mt-1">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

        <div class="form-group">
          <label for="description">
            {{ $t('inquiryHouseholdInfo.additionalInfo') }}:
          </label>

          <validation-provider
            rules="required"
            name="description"
            v-slot="{ errors }">
            <f-textarea
              v-model="data.description"
              :rows="6"
              :state="errors.length ? 'invalid' : null"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </validation-observer>

    </f-modal-body>
    <f-modal-footer>
      <div class="flex flex-justify-content-between">
        <f-button
          class="ml-0"
          theme="danger"
          @click.prevent="handleClose">
          {{ $t('ui.cancel') }}
        </f-button>
        <f-button
          class="ml-auto"
          theme="primary"
          :disabled="submitInProgress"
          @click.prevent="validateForm">
          <div
            v-if="submitInProgress"
            class="loading-spinner"
            role="status">
          </div>
          {{ $t('ui.sendAssessment') }}
        </f-button>
      </div>
    </f-modal-footer>
  </f-modal>
</template>
<script>
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'inquiry-opinion-popup',
  computed: {
  },
  data() {
    return {
      data: {
        note: 0,
        description: '',
      },
      inquiryID: 0,
      adviserName: '',
      adviserSurname: '',
      isHidden: true,
      submitInProgress: false,
      isVisible: false
    };
  },
  mounted() {
    this.$bus.$on('inquiry-opinion-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      document.body.classList.remove('no-scroll');
      this.isVisible = false;
    },
    openPopup(inquiryID, adviserName = null, adviserSurname = null) {
      this.inquiryID = inquiryID;

      if (adviserName) {
        this.adviserName = adviserName;
      }

      if (adviserSurname) {
        this.adviserSurname = adviserSurname;
      }

      this.data.note = 0;
      this.data.description = '';

      setTimeout(() => {
        this.isVisible = true;
        this.submitInProgress = false;
        document.body.classList.add('no-scroll');
        if (this.$refs['inquiry-opinion-popup-form']) {
          this.$refs['inquiry-opinion-popup-form'].reset();
        }
      }, 0);
    },
    validateForm () {
      FormUtils.validate(this.$refs['inquiry-opinion-popup-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = 'api/customer/inquiries/add-opinion/' + this.inquiryID;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: this.data,
        successTitle: this.$t('inquiryLiabilitiesInfo.sendOpinion'),
        successText: this.$t('inquiryLiabilitiesInfo.yourOpinionWasSend'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryLiabilitiesInfo.sendOpinionError'),
        successAction: () => {
          this.$bus.$emit('inquiry-reload');
          this.handleClose();
        }
      });
    },
    setRating (index) {
      this.data.note = index;
    }
  },
  beforeDestroy () {
    this.$bus.$off('inquiry-opinion-popup-show', this.openPopup);
  }
}
</script>
